/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateVendorWorkspaceDto } from '../../models/create-vendor-workspace-dto';
import { VendorWorkspaceDto } from '../../models/vendor-workspace-dto';

export interface VendorWorkspaceControllerCreate$Params {
      body: CreateVendorWorkspaceDto
}

export function vendorWorkspaceControllerCreate(http: HttpClient, rootUrl: string, params: VendorWorkspaceControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorWorkspaceDto>> {
  const rb = new RequestBuilder(rootUrl, vendorWorkspaceControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VendorWorkspaceDto>;
    })
  );
}

vendorWorkspaceControllerCreate.PATH = '/api/vendorWorkspace';
